import React from 'react'
import { RxHome } from "react-icons/rx";
import { PiBag } from "react-icons/pi";
import { AiOutlineFolder ,AiOutlineUser } from "react-icons/ai";
import { AiOutlineFile } from "react-icons/ai";
import { PiPackageLight } from "react-icons/pi";
import { NavLink ,useLocation } from 'react-router-dom';
import '../../asset/new/css/employer-modern.css';

const Sidebar = () => {
  const {pathname} = useLocation();
  return (
    <div className="employer-sidebar-wrapper">
      <div className="employer-sidebar">
        <nav className="employer-sidebar-nav">
          <NavLink 
            to={'/employer/dashboard'} 
            className={({isActive}) => `employer-sidebar-link ${isActive ? 'active' : ''}`}
          >
            <RxHome /> Home
          </NavLink>
          <NavLink 
            to={'/employer/profile'} 
            className={({isActive}) => `employer-sidebar-link ${isActive ? 'active' : ''}`}
          >
            <AiOutlineUser/> Profile
          </NavLink>
          <NavLink 
            to={'/employer/posted-jobs'} 
            className={({isActive}) => `employer-sidebar-link ${isActive ? 'active' : ''}`}
          >
            <PiBag /> Posted Jobs
          </NavLink>
          <NavLink 
            to={'/employer/folders'} 
            className={({isActive}) => `employer-sidebar-link ${isActive ? 'active' : ''}`}
          >
            <AiOutlineFolder /> My Folders
          </NavLink>
          <NavLink 
            to={'/employer/cvaccess'} 
            className={({isActive}) => `employer-sidebar-link ${isActive ? 'active' : ''}`}
          >
            <AiOutlineFile /> CV Access
          </NavLink>
          <NavLink 
            to={'/employer/package'} 
            className={({isActive}) => `employer-sidebar-link ${isActive ? 'active' : ''}`}
          >
            <PiPackageLight /> My Package
          </NavLink>
        </nav>
      </div>
    </div>
  )
}

export default Sidebar